export type BarcodeResult = {
  rawValue: string;
  format: string;
};

export function isBarcodeDetectorSupported(): boolean {
  return typeof window !== "undefined" && "BarcodeDetector" in window;
}

export async function detectBarcodesFromFile(file: File): Promise<BarcodeResult[]> {
  if (!isBarcodeDetectorSupported()) return [];
  const detector = new (window as unknown as {
    BarcodeDetector: new (opts: { formats: string[] }) => {
      detect: (src: ImageBitmapSource) => Promise<Array<{ rawValue: string; format: string }>>;
    };
  }).BarcodeDetector({
    formats: ["ean_13", "ean_8", "upc_a", "upc_e", "qr_code", "code_128"],
  });
  const bitmap = await createImageBitmap(file);
  const results = await detector.detect(bitmap);
  bitmap.close();
  return results.map((r) => ({ rawValue: r.rawValue, format: r.format }));
}

export async function lookupProductByBarcode(barcode: string): Promise<{
  name: string | null;
  strength: string | null;
  nappiCode: string | null;
} | null> {
  try {
    const res = await fetch(
      `https://world.openfoodfacts.org/api/v0/product/${encodeURIComponent(barcode)}.json`,
      { signal: AbortSignal.timeout(4000) },
    );
    if (!res.ok) return null;
    const data = await res.json();
    if (data.status !== 1) return null;
    return {
      name: data.product?.product_name ?? null,
      strength: null,
      nappiCode: barcode,
    };
  } catch {
    return null;
  }
}
